
const Config = require('config/js/lib/config.js');


module.exports = new Config({
	subsections: {
		cms: require('./cms'),
	},
});

